export { PromoCode } from './promo-code.component';
